module.exports = __webpack_public_path__ + "img/leirikeskus_original.122765cb.jpg";